<template>
  <tr>
    <td style="width:25%;"><span v-if="showCategoryName">{{ category.name }} </span></td>
    <td>
      <b-icon
        variant="primary"
        :icon="collapsed ? 'caret-down-fill' : 'caret-right-fill'"
        style="cursor: pointer;"
        @click="$emit('mealToggle')"
        v-if="showCollapse" />
    </td>
    <td>
      {{ meal.label | split }}
    </td>
    <td class="text-primary">
    <span class="pointer"
      :style="'text-decoration:' + (meal.discount ? 'line-through' : '')"
      @click="$emit('priceDetails')"
    >
    <!-- {{ meal.price + meal.tax + meal.discount | currency('&euro;')}}</span> -->
    {{ getFullPrice({ meal, noRooms, starRating, fees }) }} {{ currency }}</span>
    </td>
    <td :class="meal.discount ? 'sale-price':'info-price'  ">
    <span class="pointer"
      @click="$emit('priceDetails')"
      v-if="meal.discount"
    >
      <!-- {{ meal.price + meal.tax | currency('&euro;')}}</span> -->
      {{ getPrice({ meal, noRooms, starRating, fees }) }} {{ currency }}</span>
    </td>
    <td class="text-center">
      <span v-if="category.isSpecial" class="SPOEBD" v-b-tooltip.hover title="Oferta Speciala">
        <b-icon icon="bell" font-scale="1.3"></b-icon>
      </span>
      <span v-if="category.isEarlyBooking" class="SPOEBD" v-b-tooltip.hover title="Early Booking">
        <b-icon icon="clock-history" font-scale="1.3"></b-icon>
      </span>
      <span v-if="category.isFreePax" class="FCAVL" v-b-tooltip.hover title="Copil Gratuit">
        <b-icon icon="person-plus" font-scale="1.3"></b-icon>
      </span>
      <span v-if="status=='avl'" class="FCAVL" v-b-tooltip.hover title="Disponibil"><b-icon icon="check-circle" font-scale="1.4"></b-icon></span>
      <span v-if="status=='req'" class="RQNA" v-b-tooltip.hover title="La cerere">
       <b-icon icon="chat-quote" font-scale="1.3"></b-icon>
      </span>
      <span v-if="!transportAva || status=='n/a'" class="RQNA" v-b-tooltip.hover title="Indisponibil">
       <b-icon icon="slash-circle" font-scale="1.3"></b-icon>
      </span>
      <span :id="'warnings' + category.id + '/' + meal.id" class="text-danger mx-1" v-if="category.warnings.length">
        <b-icon icon="exclamation-octagon" font-scale="1.3"></b-icon>
      </span>
      <b-popover :target="'warnings' + category.id + '/' + meal.id" triggers="hover" placement="left" v-if="category.warnings && category.warnings.length">
        <template #title v-translate>Additional info</template>
        <div v-for="(warn, index) in category.warnings" :key="'warn'+index">
          <h6>{{ warn.label }}</h6>
          <p>{{ warn.text }}</p>
        </div>
      </b-popover>
    </td>
    <td class="text-right" v-if="showBook">
      <b-btn
        class="btn-xs"
        variant="outline-primary"
        type="button"
        v-if="transportAva && status !=='n/a' "
        @click="$emit('book')"
      ><b-icon icon="card-checklist" class="mr-2"></b-icon>{{ (status == 'req') ? 'Cerere' : 'Rezerva' }}</b-btn>
    </td>
  </tr>
</template>

<script>
import { getFullPrice, getPrice } from 'b2b-common/utils/hotel'

export default {
  props: {
    meal: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    starRating: {
      type: Number,
      default: 0
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: true
    },
    showCollapse: {
      type: Boolean,
      required: false,
      default: true
    },
    showCategoryName: {
      type: Boolean,
      required: false,
      default: true
    },
    showBook: {
      type: Boolean,
      required: false,
      default: true
    },
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    transport: {
      type: String
    },
    noRooms: {
      type: Number,
      default: 1
    }
  },
  computed: {
    status () {
      let status = 'req'
      if (this.category.hotelIsBlackedOut) status = 'n/a'
      if (this.category.hotelIsAvailable) status = 'avl'
      return status
    },
    transportAva () {
      if (this.transport === 'own') return true
      return this.category.transportIsAvailable
    }
  },
  methods: {
    getPrice, getFullPrice
  }
}
</script>

<style lang="css">
  .pointer {
    cursor:pointer;
  }
</style>
